import { render } from "./DetalleCategoria.vue?vue&type=template&id=4f84f25d"
import script from "./DetalleCategoria.vue?vue&type=script&lang=js"
export * from "./DetalleCategoria.vue?vue&type=script&lang=js"

import "./DetalleCategoria.vue?vue&type=style&index=0&id=4f84f25d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__